import React__default from 'react';

function withTUXIcon(Icon) {
  return function (props) {
    var color = props.color,
        size = props.size,
        circleBackground = props.circleBackground;
    var iconProps = {};

    if (color !== undefined) {
      iconProps.className = "text-color-".concat(color);
    }

    if (size !== undefined) {
      iconProps.fontSize = "".concat(size, "px");
    }

    if (circleBackground !== undefined) {
      var backgroundColor = circleBackground.backgroundColor,
          circleSize = circleBackground.circleSize;
      var circleSizeVal = "".concat(circleSize, "px");
      var circleBackgroundStyles = {
        width: circleSizeVal,
        height: circleSizeVal
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: "inline-flex items-center justify-center rounded-full background-color-".concat(backgroundColor),
        style: circleBackgroundStyles
      }, /*#__PURE__*/React__default.createElement(Icon, iconProps));
    }

    return /*#__PURE__*/React__default.createElement(Icon, iconProps);
  };
}

export { withTUXIcon };
